import { getInfo } from "lib/Cookies"
import { getDeviceIdFromLocal } from "lib/func"
import { useEffect } from "react"

let player, LiveOverlay

function VlinePlayer(props) {
  const {
    signKey,
    src,
    isProtected,
    contentId,
    name,
    startTime,
    posterUrl,
    children,
    isLive,
    skip_ads,
    handleError,
    id,
    type,
    isChartOn,
    onEnded
  } = props

  useEffect(() => {
    const configOverlay = {
      api: process.env.NEXT_PUBLIC_ONPLAY,
      wss: process.env.NEXT_PUBLIC_WSS,
      payment: process.env.NEXT_PUBLIC_PAY
    }
    LiveOverlay = window?.LiveOverlay
    LiveOverlay.initialize({ ...configOverlay, iframeClass: "iframeClass" })
    return () => {
      LiveOverlay?.leave()
    }
  }, [])

  useEffect(() => {
    const container = document.querySelector("#container")
    const { VinasportsPlayer } = window.playerSDK
    const __url = `https://onlivetv.vn/video?id=${id}&type=${type}`
    const userInfo = getInfo()

    if (container && src && signKey) {
      const infoPlayer = {
        src,
        contentId,
        signKey,
        posterUrl,
        licenseServer: "https://vtvlive.ondrm.com/license-api/v1/drm/licenses/widevine",
        fairplayServer: "https://vtvlive.ondrm.com/license-api/v1/drm/licenses/fairplay",
        fairplayCertificate: "https://vtvlive.ondrm.com/license-api/v1/drm/licenses/fairplay-cert",
        drm: isProtected,
        isLive,
        volume: 0.8,
        isAdOn: false,
        adTagUrl: `https://tv.springserve.com/rt/27848?w=1920&h=1080&cb=3708662946268&url=${__url}&omidpn=Google&omidpv=1&schain=1.0,1!groupm.com,148,1,,,&content_custom_1_param=18-24,25-34,35-44,45-54,55-64&content_custom_2_param=male,female,people`,
        name,
        startTime,
        iframeSrc: userInfo
          ? `${process.env.NEXT_PUBLIC_CHART_INTERACTIVE}/?id=${id}&name=${userInfo.id}&x-tenant-id=onlivetv`
          : null,
        isChartOn
      }

      player = new VinasportsPlayer(container, infoPlayer, handleError, onEnded)
      player.initialize()

      // Uncomment if needed for live views
      // if (isLive) player.showViews(countViews + 230, 230);
    }

    return () => {
      player?.destroy()
    }
  }, [src])

  useEffect(() => {
    const container = document.querySelector("#container")
    const deviceId = getDeviceIdFromLocal()

    if (player) {
      LiveOverlay?.attachTo(container)
      LiveOverlay?.join({
        mediaContentId: id,
        deviceId: deviceId,
        deviceType: "web",
        type: isLive ? 1 : 2
      })
    }
  }, [player])

  return (
    <div id="container" className="relative w-full">
      {children}
    </div>
  )
}

export default VlinePlayer
